/** Cadastros dos Tipos de Classificações */
export interface TipoClassificacaoCadastro {
    id: number;
    nome: string;
}

export const tipoClassificacaoCadastroCliente: TipoClassificacaoCadastro = {id: 1, nome: 'Cliente'};
export const tipoClassificacaoCadastroItem: TipoClassificacaoCadastro = {id: 2, nome: 'Item'};

export const tipoClassificacaoCadastros: TipoClassificacaoCadastro[] = [
    tipoClassificacaoCadastroCliente,
    tipoClassificacaoCadastroItem
];

/** Verifica se o cadastro informada é igual a Cliente */
export function isCadastroCliente(cadastro: number): boolean {
    if (!cadastro) {
        return false;
    }
    return cadastro === tipoClassificacaoCadastroCliente.id;
}

/** Verifica se o cadastro informada é igual a Item */
export function isCadastroItem(cadastro: number): boolean {
    if (!cadastro) {
        return false;
    }
    return cadastro === tipoClassificacaoCadastroItem.id;
}
